export default __webpack_public_path__ + "static/media/check-circle-blue.a69f4c22.svg";